<div class="not-found">
    <div class="d-flex flex-column align-items-center p-4 text-center">
        <!-- Logo -->
        <img src="assets/img/gallery/E4score color change.svg" alt="E4score Logo" class="logo mb-3">

        <!-- Title -->
        <h1 class="oops-text ">Oops! Page Not Found</h1>

        <!-- Message -->
        <p class="info-text mt-3">
            The page you're looking for doesn't exist or has been moved. The URL might
            be misspelled or the page has been removed.
        </p>

        <!-- Button -->
        <a href="https://e4score.com/" class="btn btn-success mt-3">Go back to home page</a>

        <!-- Support -->
        <p class="mt-3 support-text">
            If you believe this is an error, please contact our
            <a href="https://e4score.com/contact" class="support-link">support team</a>.
        </p>
    </div>
</div>